import { useEffect } from 'react';

interface UseStreamingEffectProps {
  isStreaming: boolean;
  onComplete?: () => void;
}

export function useStreamingEffect({ isStreaming, onComplete }: UseStreamingEffectProps) {
  useEffect(() => {
    if (isStreaming && onComplete) {
      onComplete();
    }
  }, [isStreaming, onComplete]);
}
